import { Tab, Tabs } from "@mui/material";
// import "../../styling/style.css";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Formik, FormikErrors } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { getBase64GeneratePdfSuratPersetujuanMaster } from "../../api/GenerateBase64PdfSuratPersetujuanMaster";
import {
  downloadFileRevision,
  requestAndReplyRevision,
} from "../../api/InsertDownloadFileRevision";
import AutocompleteDisabledComponent from "../../components/autocompletedisabled/autocomplete-disabled-mui";
import CommentDisabledComponent from "../../components/commentdisabled/textfield-disabled-mui";
import ConfirmationDialogRevisionUser from "../../components/confirmationdialogrevisionuser/confirmation-dialog-revision-user";
import CRRNumberField from "../../components/crrnumberfield/crr-number-field-mui";
import ConfirmationDialog from "../../components/dialog/simple-alert";
import DropdownlistDisabledComponent from "../../components/dropdownlistdisabled/dropdownlist-disabled-mui";
import DropdownlistDisabledValidationComponent from "../../components/dropdownlistvalidationdisabled/dropdownlist-validation-disabled-mui";
import Feedback from "../../components/feedback/feedback";
import Loading from "../../components/loading/loading";
import RevisionDisabledComponent from "../../components/revisiondisabled/revision-by-end-user-disabled-mui";
import TextAreaDisabledComponent from "../../components/textareadisabled/textarea-disabled-mui";
import TextFieldDateDisabledComponent from "../../components/textfielddatedisabled/textfield-date-disabled-mui";
import TextFieldDisabledComponent from "../../components/textfielddisabled/textfield-disabled-mui";
import TextFieldMultiDisabledComponent from "../../components/textfieldmultidisabled/textfield-multi-disabled-mui";
import UploadMultipleFileComponent from "../../components/uploadmultiplefile/UploadMultipleFile";
import { IDataComment } from "../../interfaces/IDataComment";
import { IDataRevision } from "../../interfaces/IDataRevision";
import { IDataUploadComment } from "../../interfaces/IDataUploadComment";
import { NewIDataUploadItem } from "../../interfaces/IDataUploadItem";
import { IDataUploadRevision } from "../../interfaces/IDataUploadRevision";
import { IForm } from "../../interfaces/IForm";
import { TransactionHistoryModal } from "../../shared/Components/TransactionHistoryModal";
import { DocumentType, RequestStatus, RequestType } from "../../shared/Enum";
import { RoleStatus } from "../../shared/Enum/RoleStatus";
import {
  FilterDistinctByIdAndSort,
  RemoveDateFromFileName,
} from "../../shared/functions";
import {
  selectNewProfile,
  selectNewProfileRole,
} from "../../store/newProfile/selector";
import { homeStyle } from "../../styles/container/home";
import {
  downloadFileComment,
  downloadSingleFile,
  getListAreaLocation,
  getListDocumentType,
  getListRequestType,
  getSharepointToken,
  getSingleDataRequest,
} from "./api-endpoint/callApi";

const getBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    reader.addEventListener("error", (error) => {
      reject(error);
    });
    reader.readAsDataURL(file);
  });

const handleChangeDownloadRevision = (data) => {
  const downloadLink = document.createElement("a");
  if (data.fileBase64 != "") {
    downloadLink.href = data.fileBase64;
    downloadLink.download = data.fileName;
    downloadLink.click();
  }
};

function ViewForm() {
  const { id } = useParams();
  const [listDocumentType, setListDocumentType] = useState([]);
  const [listAreaLocation, setListAreaLocation] = useState([]);
  const [listRequestType, setListRequestType] = useState([]);
  const [validationDocumentType, setValidationDocumentType] = useState(
    DocumentType.toId(DocumentType.Softcopy)
  );
  const [validationRequestType, setValidationRequestType] = useState(
    RequestType.toId(RequestType.SuratKuasa)
  );
  const [validationSignerAndLeader, setValidationSignerAndLeader] =
    useState(false);
  const [sharepoint, setSharepoint] = useState<any>({ token: "", expToken: 0 });
  const [errorUpload, setErrorUpload] = useState("");
  const [errorUploadSK, setErrorUploadSK] = useState("");

  const [globalDocumentType, setGlobalDocumentType] = useState("");
  const [formData, setFormData] = useState<IForm | undefined>();
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openConfirmationSubmit, setOpenConfirmationSubmit] = useState(false);
  const [loadingActive, setLoadingActive] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [openFeedback, setOpenFeedback] = useState(false);
  const [comment, setComment] = useState("");
  // const [revisionNote, setRevisionNote] = useState("");
  const [requestDate, setRequestDate] = useState("");
  const [valGrantDate, setValGrantDate] = useState("");
  const [requestStatusID, setRequestStatusID] = useState("");
  const [enableNoteGrantDate, setEnableNoteGrantDate] = useState(false);
  const [dataCommentEndUser, setDataCommentEndUser] = useState<IDataComment[]>(
    []
  );
  const [dataCommentCL, setDataCommentCL] = useState<IDataComment[]>([]);
  const [userRevision, setUserRevision] = useState(0);

  const [crrNumber, setCrrNumber] = useState("");
  const [requestTypeId, setRequestTypeId] = useState("");
  const [requestStatusName, setRequestStatusName] = useState("");

  const [dataUpload, setDataUpload] = useState<NewIDataUploadItem[]>([
    {
      title: "Unggah Draft Final / Upload Final Draft*",
      fileType: "Draft Final",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);

  const [uploadSK, setUploadSK] = useState<NewIDataUploadItem[]>([
    {
      title: "Unggah SK / Upload SK*",
      fileType: "Hardcopy SK",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);

  const [fileSuratPersetujuanGeneratePdf, setFileSuratPersetujuanGeneratePdf] =
    useState<NewIDataUploadItem[]>([
      {
        title: "",
        fileType: "Surat Persetujuan Penggunaan Master Dokumen",
        files: [
          {
            documentID: "",
            fileBase64: "",
            fileName: "",
            folderName: "",
          },
        ],
      },
    ]);

  const [uploadRealizationDM, setUploadRealizationDM] = useState<
    NewIDataUploadItem[]
  >([
    {
      title:
        "Unggah Realisasi Dokumen Master / Upload Master Document Realization*",
      fileType: "Master Document Realization",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);

  const [tempRevisionData, setTempRevisionData] = useState<{
    comment: string;
    data: NewIDataUploadItem[];
  }>({
    comment: "",
    data: [
      {
        title: "Bukti / Evidence",
        fileType: "Evidence",
        files: [
          { documentID: "", fileBase64: "", fileName: "", folderName: "" },
        ],
      },
    ],
  });
  const [dataUploadComment, setDataUploadComment] =
    useState<IDataUploadComment>({
      commentID: "",
      fileBase64: "",
      fileName: "",
    });

  const [dataUploadRevision, setDataUploadRevision] =
    useState<IDataUploadRevision>({
      revisionID: "",
      fileBase64: "",
      fileName: "",
    });

  const [listDataRevision, setListDataRevision] = useState<IDataRevision[]>([]);

  const [errorUploadComment, setErrorUploadComment] = useState("");
  const [actionButtonClick, setActionButtonClick] = useState("");
  const [requestNumber, setRequestNumber] = useState("");

  const [valueTab, setValueTab] = useState(0);
  const getRole = useSelector(selectNewProfileRole);
  const profile = useSelector(selectNewProfile);
  const today = new Date();
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const reqDate = `${today.getDate()} ${
    month[today.getMonth()]
  } ${today.getFullYear()}`;
  const Navigate = useNavigate();

  const initialValues: IForm = {
    startDatePeriod: "",
    endDatePeriod: "",
    binusianID: "",
    email: "",
    binusianName: "",
    businessUnit: "",
    department: "",
    title: "",
    buLeader: "",
    extension: "",
    documentType: DocumentType.toId(DocumentType.Softcopy),
    requestType: RequestType.toId(RequestType.SuratKuasa),
    dateOfPower: "",
    dateGrantOfPower: "",
    clNote: "",
    lrNote: "",
    signer: null,
    titleAgreement: "",
    area: "Anggrek",
    address: "",
    counterPart: "",
    requestDate: "",
    substitutor: null,
    delegatee: null,
    noPowerAttorney: "",
    noSubstitutor: "",
  };

  const getDocumentType = async () => {
    try {
      // get all data for table list User
      const ltDocumentType = await getListDocumentType();
      // console.log(ltDocumentType);
      setListDocumentType(ltDocumentType);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  const getAreaLocation = async () => {
    try {
      // get all data for table list User
      const tempDataAreaLocation: any = [];
      const ltAreaLocation = await getListAreaLocation();
      const jsonParse = JSON.parse(ltAreaLocation);
      jsonParse.data.forEach((datas: any) => {
        tempDataAreaLocation.push({
          label: datas.locationHierarcy.text,
          value: datas.locationHierarcy.id,
        });
      });
      const distinctLocation = FilterDistinctByIdAndSort(tempDataAreaLocation);
      setListAreaLocation(distinctLocation);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  const getRequestType = async () => {
    try {
      // get all data for table list User
      const msRequestType = await getListRequestType();
      setListRequestType(msRequestType);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  /* eslint-disable unicorn/consistent-function-scoping */
  function transformSingleData(data): any[] {
    const categoryMap = {
      "Draft Final": "Unggah Draft Final / Upload Final Draft*",
      "Approval BU Leader": "Approval BU Leader / BU Leader Approval*",
      "Partner Request": "Unggah Permohonan Partner / Upload Partner Request",
      "Master Document Realization":
        "Unggah Realisasi Dokumen Master / Upload Master Document Realization*",
      "Hardcopy SK": "Unggah SK / Upload SK*",
    };
    const categoryKey = {
      "Draft Final": 1,
      "Approval BU Leader": 2,
      "Partner Request": 3,
      "Master Document Realization": 4,
      "Hardcopy SK": 5,
    };
    const orderedCategoryKeys = Object.keys(categoryKey).sort(
      (a, b) => categoryKey[a] - categoryKey[b]
    );

    const groupedData = data.reduce((acc, item) => {
      const { category, documentID, documentName, link } = item;
      const newTitleName = categoryMap[category] || category;
      const newCategory = categoryKey[category]
        ? category
        : categoryKey[category];
      acc[newCategory] = acc[newCategory] || {
        title: newTitleName,
        fileType: category,
        files: [],
      };
      acc[newCategory].files.push({
        documentID,
        fileBase64: "",
        fileName: documentName,
        folderName: link,
      });
      return acc;
    }, {});

    return orderedCategoryKeys
      .map((key) => groupedData[key])
      .filter((item) => item !== undefined);
  }
  /* eslint-enable unicorn/consistent-function-scoping */

  // eslint-disable-next-line consistent-return
  const getSingleData = async () => {
    try {
      // get all data for table list User
      const getSingleRequest = await getSingleDataRequest(id);

      setRequestStatusName(getSingleRequest.trRequest.requestStatusName);
      setRequestNumber(getSingleRequest.trRequest.requestNumber);
      setCrrNumber(getSingleRequest.trRequest.noCRR);
      setRequestStatusID(getSingleRequest.trRequest.requestStatusID);
      setRequestTypeId(getSingleRequest.trRequest.requestTypeID);
      if (getSingleRequest.trRequest.userRevision) {
        setUserRevision(getSingleRequest.trRequest.userRevision);
      }

      // profile
      initialValues.binusianName = getSingleRequest.trRequest.binusianName;
      initialValues.businessUnit = getSingleRequest.trRequest.businessUnit;
      initialValues.department = getSingleRequest.trRequest.department;
      initialValues.title = getSingleRequest.trRequest.title;
      initialValues.buLeader = getSingleRequest.trRequest.buLeader;
      initialValues.extension = getSingleRequest.trRequest.ext;

      // case Soft Copy
      setRequestDate(
        moment(getSingleRequest.trRequest.requestDate).format("DD MMMM YYYY")
      );
      initialValues.dateOfPower = moment(
        getSingleRequest.trRequest.poaDate
      ).format("YYYY-MM-DD");
      if (getSingleRequest.trRequest.dateGrantOfPower !== null) {
        initialValues.dateGrantOfPower = moment(
          getSingleRequest.trRequest.dateGrantOfPower
        ).format("YYYY-MM-DD");
        setValGrantDate(getSingleRequest.trRequest.dateGrantOfPower);
        initialValues.clNote = getSingleRequest.trRequest.clNote;
        initialValues.lrNote = getSingleRequest.trRequest.lrNote;
        // if (
        //   getSingleRequest.trRequest.dateGrantOfPower <=
        //   getSingleRequest.trRequest.poaDate
        // ) {
        //   setEnableNoteGrantDate(false);
        // } else {
        //   setEnableNoteGrantDate(true);
        // }
      }
      initialValues.signer = {
        binusianIDEmail: getSingleRequest.trRequest.signer.split("#")[0],
        name: getSingleRequest.trRequest.signer.split("#")[1],
      };
      if (
        getSingleRequest.trRequest.signer.split("#")[0].split("~")[1].trim() ==
        getSingleRequest.trRequest.buLeaderBinusianID.trim()
      ) {
        setValidationSignerAndLeader(true);
      }
      initialValues.titleAgreement = getSingleRequest.trRequest.titleAgreement;
      initialValues.counterPart = getSingleRequest.trRequest.counterpart;
      initialValues.documentType = getSingleRequest.trRequest.documentTypeID;
      if (getSingleRequest.trRequest.startMasterUsePeriod !== null) {
        initialValues.startDatePeriod = moment(
          getSingleRequest.trRequest.startMasterUsePeriod
        ).format("YYYY-MM-DD");
        initialValues.endDatePeriod = moment(
          getSingleRequest.trRequest.endMasterUsePeriod
        ).format("YYYY-MM-DD");
      }

      setValidationDocumentType(getSingleRequest.trRequest.documentTypeID);
      setGlobalDocumentType(getSingleRequest.trRequest.documentTypeID);
      // case Hard Copy
      if (
        getSingleRequest.trRequest.documentTypeID ==
        DocumentType.toId(DocumentType.Hardcopy)
      ) {
        initialValues.area = getSingleRequest.trRequest.area;
        initialValues.address = getSingleRequest.trRequest.detailArea;
      }

      const filteredJustMultiUpload = getSingleRequest.trDocument.filter(
        (item) =>
          item.category !== "Hardcopy SK" &&
          item.category !== "Master Document Realization"
      );

      const transformedData = transformSingleData(filteredJustMultiUpload);
      if (transformedData.length == 2) {
        const newItem: NewIDataUploadItem = {
          title: "Unggah Permohonan Partner / Upload Partner Request",
          fileType: "Partner Request",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        };
        transformedData.push(newItem);
      }

      const transformedDataRealization = transformSingleData(
        getSingleRequest.trDocument.filter(
          (item) => item.category == "Master Document Realization"
        )
      );

      const transformedDataSK = transformSingleData(
        getSingleRequest.trDocument.filter(
          (item) => item.category == "Hardcopy SK"
        )
      );

      if (transformedDataRealization.length > 0) {
        setUploadRealizationDM(transformedDataRealization);
      }
      if (transformedDataSK.length > 0) {
        setUploadSK(transformedDataSK);
      }

      setDataUpload(transformedData);

      if (getSingleRequest.trComment.length > 0) {
        const filteredCommentEnduser = getSingleRequest.trComment.filter(
          (item) => item.toRole === "RL230000002"
        );
        setDataCommentEndUser(filteredCommentEnduser);

        const filteredCommentCL = getSingleRequest.trComment.filter(
          (item) => item.toRole === "RL230000003"
        );
        setDataCommentCL(filteredCommentCL);
      }

      if (getSingleRequest.trRevision.length > 0) {
        setListDataRevision(getSingleRequest.trRevision);
      }

      if (getSingleRequest.trRequest.requestTypeID !== null) {
        initialValues.requestType = getSingleRequest.trRequest.requestTypeID;
        setValidationRequestType(getSingleRequest.trRequest.requestTypeID);
      }

      if (getSingleRequest.trRequest.delegatee != null) {
        initialValues.delegatee = {
          binusianIDEmail: getSingleRequest.trRequest.delegatee.split("#")[0],
          name: getSingleRequest.trRequest.delegatee.split("#")[1],
        };
      }

      if (getSingleRequest.trRequest.substitutor != null) {
        initialValues.substitutor = {
          binusianIDEmail: getSingleRequest.trRequest.substitutor.split("#")[0],
          name: getSingleRequest.trRequest.substitutor.split("#")[1],
        };
      }
      initialValues.noPowerAttorney = getSingleRequest.trRequest.noPOA;
      initialValues.noSubstitutor = getSingleRequest.trRequest.noSubstitution;
      if (
        (getSingleRequest.trRequest.requestStatusName ==
          RequestStatus.Finished ||
          getSingleRequest.trRequest.requestStatusName ==
            RequestStatus.FinishedRevised ||
          getSingleRequest.trRequest.requestStatusName ==
            RequestStatus.FinishedCanceled ||
          getSingleRequest.trRequest.requestStatusName ==
            RequestStatus.RequestRevise) &&
        getSingleRequest.trRequest.requestTypeID ==
          RequestType.toId(RequestType.DokumenMaster) &&
        id !== undefined
      ) {
        getBase64GeneratePdfSuratPersetujuanMaster(
          id,
          `Surat Persetujuan Penggunaan Master Dokumen_${moment(
            getSingleRequest.finishedDate
          ).format("DDMMYYYY")}.pdf`
        ).then((res) =>
          setFileSuratPersetujuanGeneratePdf((prev) => {
            const data: NewIDataUploadItem = {
              ...prev[0],
              files: [
                {
                  ...prev[0].files[0],
                  documentID: res,
                  fileName: `Surat Persetujuan Penggunaan Master Dokumen_${moment(
                    getSingleRequest.finishedDate
                  ).format("DDMMYYYY")}.pdf`,
                  fileBase64: res,
                },
              ],
            };
            return [data];
          })
        );
      }

      const dbCRR = getSingleRequest.trRequest.noCRR;
      setCrrNumber(dbCRR);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  const handleClickRevision = async (e: {
    comment: string;
    data: NewIDataUploadItem[];
  }) => {
    // validasi penjagaan sebelum submit file
    if (e.comment.trim() != "") {
      setTempRevisionData(e);
      // setOpenConfirmation(false);
      setOpenConfirmationSubmit(true);
    }
  };

  const handleRequestRevision = (action) => {
    setOpenConfirmation(true);
    setActionButtonClick(action);
    const newDataUploadRevision = {
      revisionID: "",
      fileBase64: "",
      fileName: "",
    };
    setDataUploadRevision(newDataUploadRevision);
  };

  const handleSubmitRequestRevision = async (data: {
    comment: string;
    data: NewIDataUploadItem[];
  }) => {
    setOpenConfirmationSubmit(false);
    setLoadingActive(true);

    const insertRevision = await requestAndReplyRevision(
      id,
      profile.BinusianId,
      data.comment.trim(),
      data.data,
      RequestStatus.toId(RequestStatus.RequestRevise),
      RoleStatus.toId(RoleStatus.EndUser), // role id end user
      RoleStatus.toId(RoleStatus.LegalRelation) // role id legal relation
    );

    setLoadingActive(false);
    if (insertRevision.resultCode === 200) {
      setFeedbackText("Your data has been successfully saved!");
      setFeedbackType("success");
      setOpenFeedback(true);
      setTimeout(() => {
        Navigate("/");
      }, 3000);
    } else {
      setFeedbackText(insertRevision.errorMessage);
      setFeedbackType("failed");
      setOpenFeedback(true);
    }
  };

  const handleChangeUploadRevision = async (data) => {
    if (data != undefined) {
      const resultBase64File: any = await getBase64(data).then(
        (bs64: any) => bs64
      );

      const newFileNameWithoutDate = RemoveDateFromFileName(data.name);
      const filteredSameFileNameRevision = listDataRevision.filter(
        (item) => item.additionalDoc === newFileNameWithoutDate
      );

      if (filteredSameFileNameRevision.length === 0) {
        const newDataUploadRevision = {
          revisionID: "",
          fileBase64: resultBase64File,
          fileName: data.name,
        };
        setDataUploadRevision(newDataUploadRevision);
        setErrorUploadComment("");
      } else {
        setFeedbackText("The file already exists, please change the file name");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
      }
    }
  };

  const handleChangeDeleteRevision = () => {
    const newDataUploadRevision = {
      revisionID: "",
      fileBase64: "",
      fileName: "",
    };
    setDataUploadRevision(newDataUploadRevision);
    setErrorUploadComment("");
  };

  const handleDownloadSuratPersetujuanGeneratePdf = async (
    type,
    dataIndex,
    fileIndex
  ) => {
    const getDataUpload = [...fileSuratPersetujuanGeneratePdf];
    const downloadLink = document.createElement("a");

    const { fileName } = getDataUpload[0].files[fileIndex];
    setLoadingActive(true);
    const getBase64PdfSuratPersetujuan =
      await getBase64GeneratePdfSuratPersetujuanMaster(id, fileName);
    setLoadingActive(false);
    downloadLink.download = fileName;
    downloadLink.href = getBase64PdfSuratPersetujuan;

    downloadLink.click();
  };

  // useEffect(() => {
  //   getDocumentType();
  //   getAreaLocation();
  //   console.log("id url:", id);
  //   if (id !== undefined) {
  //     // get api data
  //     getSingleData();
  //     setValueTab(1);
  //   }
  // }, []);

  useEffect(() => {
    const firstLoad = async () => {
      setLoadingActive(true);
      await getDocumentType();
      await getAreaLocation();
      await getRequestType();
      if (id !== undefined) {
        // get api data
        await getSingleData();
        setValueTab(1);
      }
      setLoadingActive(false);
    };
    firstLoad();
  }, []);

  const validation = (values: IForm) => {
    const errors: FormikErrors<IForm | undefined> = {};
    if (values.dateOfPower === "") {
      errors.dateOfPower = "Date of Power of Attorney must be filled";
    }
    if (
      values.startDatePeriod === "" &&
      validationRequestType === RequestType.toId(RequestType.DokumenMaster)
    ) {
      errors.startDatePeriod = "Start Date Period must be filled";
    }
    if (
      values.endDatePeriod === "" &&
      validationRequestType === RequestType.toId(RequestType.DokumenMaster)
    ) {
      errors.endDatePeriod = "End Date Period must be filled";
    }
    if (
      values.startDatePeriod !== "" &&
      values.endDatePeriod !== "" &&
      values.endDatePeriod < values.startDatePeriod &&
      validationRequestType === RequestType.toId(RequestType.DokumenMaster)
    ) {
      errors.endDatePeriod = "End Date must not be earlier than Start Date";
    }
    if (values.titleAgreement === "") {
      errors.titleAgreement = "Title of Agreement must be filled";
    }
    if (
      values.address === "" &&
      values.documentType == DocumentType.toId(DocumentType.Hardcopy)
    ) {
      errors.address = "Address must be filled";
    }
    if (values.counterPart === "") {
      errors.counterPart = "Counterpart must be filled";
    }
    if (values.signer === null) {
      errors.signer = "Signer must be filled";
    }
    if (values.delegatee === null) {
      errors.delegatee = "Delegatee must be filled";
    }
    if (values.noPowerAttorney === "" || values.noPowerAttorney === null) {
      errors.noPowerAttorney = "Number of power attorney must be filled";
    }

    const checkFileRequired = dataUpload.some(
      (item) =>
        item.title.includes("*") &&
        item.files.some((file) => file.fileName === "")
    );

    if (checkFileRequired) {
      setErrorUpload("Please upload required file");
    } else {
      setErrorUpload("");
    }

    return errors;
  };

  const onResetForm = () => {
    setValidationDocumentType(globalDocumentType);
  };

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  const handleChangeDownload = async (
    type,
    dataIndex,
    fileIndex,
    singleFileCategory
  ) => {
    const getDataUpload = [...dataUpload];
    const downloadLink = document.createElement("a");

    // eslint-disable-next-line unicorn/consistent-function-scoping, consistent-return
    const downloadFile = async () => {
      try {
        // get all data for table list User
        const currentTime: any = new Date();
        const differenceInMinutesTokenSharepoint: any =
          (sharepoint.expToken - currentTime) / 1000 / 60;

        if (differenceInMinutesTokenSharepoint < 10) {
          const tokenSharepoint = await getSharepointToken();
          setSharepoint({
            ...sharepoint,
            token: tokenSharepoint.token,
            expToken: new Date(currentTime.getTime() + 30 * 60 * 1000),
          });
          // lakukan download
          if (type == "multi") {
            const getBase64Download = await downloadSingleFile(
              getDataUpload[dataIndex].files[fileIndex].fileName,
              getDataUpload[dataIndex].fileType,
              id,
              tokenSharepoint.token
            );
            return getBase64Download;
          }
          switch (singleFileCategory) {
            case "Hardcopy SK": {
              const getBase64Download = await downloadSingleFile(
                uploadSK[0].files[fileIndex].fileName,
                uploadSK[0].fileType,
                id,
                tokenSharepoint.token
              );
              return getBase64Download;
            }
            case "Master Document Realization": {
              const getBase64Download = await downloadSingleFile(
                uploadRealizationDM[0].files[fileIndex].fileName,
                uploadRealizationDM[0].fileType,
                id,
                tokenSharepoint.token
              );
              return getBase64Download;
            }
          }
        }
        // eslint-disable-next-line no-else-return
        else {
          if (type == "multi") {
            const getBase64Download = await downloadSingleFile(
              getDataUpload[dataIndex].files[fileIndex].fileName,
              getDataUpload[dataIndex].fileType,
              id,
              sharepoint.token
            );
            return getBase64Download;
          }
          switch (singleFileCategory) {
            case "Hardcopy SK": {
              const getBase64Download = await downloadSingleFile(
                uploadSK[0].files[fileIndex].fileName,
                uploadSK[0].fileType,
                id,
                sharepoint.token
              );
              return getBase64Download;
            }
            case "Master Document Realization": {
              const getBase64Download = await downloadSingleFile(
                uploadRealizationDM[0].files[fileIndex].fileName,
                uploadRealizationDM[0].fileType,
                id,
                sharepoint.token
              );
              return getBase64Download;
            }
          }
        }
      } catch (error) {
        // Handle error if needed
        console.log("Error fetching data:", error);
      }
    };

    setLoadingActive(true);
    const tempBase64File = await downloadFile();
    setLoadingActive(false);
    if (type == "multi") {
      if (getDataUpload[dataIndex].files[fileIndex].documentID != "") {
        getDataUpload[dataIndex].files[fileIndex].fileBase64 = tempBase64File;
      }
      if (getDataUpload[dataIndex].files[fileIndex].fileBase64 != "") {
        downloadLink.href =
          getDataUpload[dataIndex].files[fileIndex].fileBase64;
        downloadLink.download =
          getDataUpload[dataIndex].files[fileIndex].fileName;
        downloadLink.click();
      }
    } else {
      switch (singleFileCategory) {
        case "Hardcopy SK": {
          if (uploadSK[0].files[fileIndex].documentID != "") {
            uploadSK[0].files[fileIndex].fileBase64 = tempBase64File;
          }
          if (uploadSK[0].files[fileIndex].fileBase64 != "") {
            downloadLink.href = uploadSK[0].files[fileIndex].fileBase64;
            downloadLink.download = uploadSK[0].files[fileIndex].fileName;
            downloadLink.click();
          }
          break;
        }
        case "Master Document Realization": {
          if (uploadRealizationDM[0].files[fileIndex].documentID != "") {
            uploadRealizationDM[0].files[fileIndex].fileBase64 = tempBase64File;
          }
          if (uploadRealizationDM[0].files[fileIndex].fileBase64 != "") {
            downloadLink.href =
              uploadRealizationDM[0].files[fileIndex].fileBase64;
            downloadLink.download =
              uploadRealizationDM[0].files[fileIndex].fileName;
            downloadLink.click();
          }
          break;
        }
      }
    }
  };

  const handleChangeDownloadCommentEndUser = async (data, i) => {
    const getDataComment = [...dataCommentEndUser];
    const downloadLink = document.createElement("a");

    // eslint-disable-next-line unicorn/consistent-function-scoping, consistent-return
    const downloadFile = async () => {
      try {
        // get all data for table list User
        const currentTime: any = new Date();
        const differenceInMinutesTokenSharepoint: any =
          (sharepoint.expToken - currentTime) / 1000 / 60;

        if (differenceInMinutesTokenSharepoint < 10) {
          const tokenSharepoint = await getSharepointToken();
          setSharepoint({
            ...sharepoint,
            token: tokenSharepoint.token,
            expToken: new Date(currentTime.getTime() + 30 * 60 * 1000),
          });
          // lakukan download
          const getBase64Download = await downloadFileComment(
            getDataComment[i].commentID,
            id,
            tokenSharepoint.token
          );
          return getBase64Download;
        }
        // eslint-disable-next-line no-else-return
        else {
          const getBase64Download = await downloadFileComment(
            getDataComment[i].commentID,
            id,
            sharepoint.token
          );
          return getBase64Download;
        }
      } catch (error) {
        // Handle error if needed
        console.log("Error fetching data:", error);
      }
    };

    setLoadingActive(true);
    const tempBase64File = await downloadFile();
    setLoadingActive(false);
    if (getDataComment[i].commentID != "") {
      getDataComment[i].fileBase64 = tempBase64File;
    }

    if (getDataComment[i].fileBase64 != "") {
      downloadLink.href = getDataComment[i].fileBase64;
      downloadLink.download = getDataComment[i].evidence;
      downloadLink.click();
    }
  };

  const handleChangeDownloadCommentEndUserAndCL = async (
    data,
    i,
    typeComment
  ) => {
    const getDataComment =
      typeComment == "End User" ? [...dataCommentEndUser] : [...dataCommentCL];
    const downloadLink = document.createElement("a");

    // eslint-disable-next-line unicorn/consistent-function-scoping, consistent-return
    const downloadFile = async () => {
      try {
        // get all data for table list User
        const currentTime: any = new Date();
        const differenceInMinutesTokenSharepoint: any =
          (sharepoint.expToken - currentTime) / 1000 / 60;

        if (differenceInMinutesTokenSharepoint < 10) {
          const tokenSharepoint = await getSharepointToken();
          setSharepoint({
            ...sharepoint,
            token: tokenSharepoint.token,
            expToken: new Date(currentTime.getTime() + 30 * 60 * 1000),
          });
          // lakukan download
          const getBase64Download = await downloadFileComment(
            getDataComment[i].commentID,
            id,
            tokenSharepoint.token
          );
          return getBase64Download;
        }
        // eslint-disable-next-line no-else-return
        else {
          const getBase64Download = await downloadFileComment(
            getDataComment[i].commentID,
            id,
            sharepoint.token
          );
          return getBase64Download;
        }
      } catch (error) {
        // Handle error if needed
        console.log("Error fetching data:", error);
      }
    };

    setLoadingActive(true);
    const tempBase64File = await downloadFile();
    setLoadingActive(false);
    if (getDataComment[i].commentID != "") {
      getDataComment[i].fileBase64 = tempBase64File;
    }

    if (getDataComment[i].fileBase64 != "") {
      downloadLink.href = getDataComment[i].fileBase64;
      downloadLink.download = getDataComment[i].evidence;
      downloadLink.click();
    }
  };

  const handleChangeDownloadRevisionByUser = async (data, i) => {
    const getDataRevision = [...listDataRevision];
    const downloadLink = document.createElement("a");

    // eslint-disable-next-line unicorn/consistent-function-scoping, consistent-return
    const downloadFileRevisi = async () => {
      try {
        // get all data for table list User
        const currentTime: any = new Date();
        const differenceInMinutesTokenSharepoint: any =
          (sharepoint.expToken - currentTime) / 1000 / 60;

        if (differenceInMinutesTokenSharepoint < 10) {
          const tokenSharepoint = await getSharepointToken();
          setSharepoint({
            ...sharepoint,
            token: tokenSharepoint.token,
            expToken: new Date(currentTime.getTime() + 30 * 60 * 1000),
          });
          // lakukan download
          const getBase64Download = await downloadFileRevision(
            getDataRevision[i].revisionID,
            id,
            tokenSharepoint.token
          );
          return getBase64Download;
        }
        // eslint-disable-next-line no-else-return
        else {
          const getBase64Download = await downloadFileRevision(
            getDataRevision[i].revisionID,
            id,
            sharepoint.token
          );
          return getBase64Download;
        }
      } catch (error) {
        // Handle error if needed
        console.log("Error fetching data:", error);
      }
    };

    setLoadingActive(true);
    const tempBase64File = await downloadFileRevisi();
    setLoadingActive(false);
    if (getDataRevision[i].revisionID != "") {
      getDataRevision[i].fileBase64 = tempBase64File;
    }

    if (getDataRevision[i].fileBase64 != "") {
      downloadLink.href = getDataRevision[i].fileBase64;
      downloadLink.download = getDataRevision[i].additionalDoc;
      downloadLink.click();
    }
  };

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px", padding: 0, margin: 0 }}>
        <div className="tabs-container">Home {">"} View</div>
        <div className="tabs-container">
          <hr style={{ color: "black", width: "100%" }} />
        </div>
      </Box>
      <Grid item lg={12} md={12} xs={12}>
        <div style={{ display: "flex" }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ marginLeft: "23px", width: "300px" }}
          >
            <b>
              No. Request / <i>Request Number</i>
            </b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "15px" }}
          >
            <b>:</b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "250px" }}
          >
            <b>{requestNumber}</b>
          </Typography>
        </div>
      </Grid>
      <Grid item lg={12} md={12} xs={12}>
        <div style={{ display: "flex" }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ marginLeft: "23px", width: "300px" }}
          >
            <b>
              Tanggal Permintaan / <i>Request Date</i>
            </b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "15px" }}
          >
            <b>:</b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "200px" }}
          >
            <b>{requestDate}</b>
          </Typography>
        </div>
      </Grid>
      <Grid item lg={12} md={12} xs={12}>
        <CRRNumberField
          crrNumber={crrNumber}
          crrNumError=""
          isDisabled
          onCRRChange={() => {}}
        />
      </Grid>
      <div className="tabs-container" style={{ marginTop: "1.5%" }}>
        <Tabs value={valueTab} onChange={handleChangeTab} textColor="primary">
          <Tab
            style={{ color: valueTab === 0 ? "#fff" : "#000" }}
            color="primary"
            label="Data Diri / Profile"
            className={valueTab === 0 ? "active-tab-panel" : "hidden-tab-panel"}
          />

          <Tab
            style={{ color: valueTab === 1 ? "#fff" : "#000" }}
            color="primary"
            label="Permohonan Detil / Detail Request"
            className={valueTab === 1 ? "active-tab-panel" : "hidden-tab-panel"}
          />

          <Tab
            style={{ color: valueTab === 2 ? "#fff" : "#000" }}
            color="primary"
            label="Workflow"
            className={valueTab === 2 ? "active-tab-panel" : "hidden-tab-panel"}
          />
        </Tabs>
      </div>
      <div className="tabs-container">
        <hr className="tab-line" />
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={() => {}}
        validate={validation}
        onReset={onResetForm}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit} onReset={props.handleReset}>
            <TabPanel value={valueTab} index={0}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Pemohon / <i>Applicant</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="binusianName"
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Jabatan / <i>Title</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent propsData={props} name="title" />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Divisi / <i>Business Unit</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="businessUnit"
                  />
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "25px" }}
                    gutterBottom
                  >
                    <u>Business Unit Leader</u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="buLeader"
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Department / <i>Department</i>
                    </u>
                  </Typography>
                  <TextFieldMultiDisabledComponent
                    propsData={props}
                    name="department"
                  />
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "40px" }}
                    gutterBottom
                  >
                    <u>
                      Ekstensi / <i>Extension</i> (Ext.)
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="extension"
                  />
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  paddingTop: "20px",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(1)}
                >
                  Next Page {">>"}
                </Button>
              </Box>
            </TabPanel>
            <TabPanel value={valueTab} index={1}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} xs={12}>
                  {getRole.roleId == "RL230000002" && valGrantDate != "" ? (
                    <>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontSize: "0.98rem" }}
                        gutterBottom
                      >
                        <u>
                          Tanggal Pemberian Surat Kuasa /{" "}
                          <i>Date of Granting of Power of Attorney</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <TextFieldDateDisabledComponent
                        propsData={props}
                        name="dateGrantOfPower"
                      />
                      {props.errors.dateGrantOfPower && (
                        <div className="error-message">
                          {props.errors.dateGrantOfPower}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Tanggal Surat Kuasa / <i>Date of Power of Attorney</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <TextFieldDateDisabledComponent
                        propsData={props}
                        name="dateOfPower"
                      />
                      {props.errors.dateOfPower && (
                        <div className="error-message">
                          {props.errors.dateOfPower}
                        </div>
                      )}
                    </>
                  )}

                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "20px" }}
                    gutterBottom
                  >
                    <u>
                      Pihak Penandatangan / <i>Signer</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <AutocompleteDisabledComponent
                    propsData={props}
                    name="signer"
                  />
                  {props.errors.signer && (
                    <div className="error-message">{props.errors.signer}</div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {getRole.roleId != "RL230000002" && (
                    <>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontSize: "0.98rem" }}
                        gutterBottom
                      >
                        <u>
                          Tanggal Pemberian Surat Kuasa /{" "}
                          <i>Date of Granting of Power of Attorney</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <TextFieldDateDisabledComponent
                        propsData={props}
                        name="dateGrantOfPower"
                      />
                      {props.errors.dateGrantOfPower && (
                        <div className="error-message">
                          {props.errors.dateGrantOfPower}
                        </div>
                      )}
                      <Typography
                        variant="subtitle1"
                        style={{
                          paddingTop: "20px",
                        }}
                        gutterBottom
                      >
                        <u>
                          Catatan Legal / <i>Legal Notes</i>
                        </u>
                      </Typography>
                      <Grid item lg={12} md={12} xs={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Corporate Legal:
                        </Typography>
                        <TextAreaDisabledComponent
                          propsData={props}
                          name="clNote"
                        />
                      </Grid>
                      <Grid item lg={12} md={12} xs={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Legal Relation:
                        </Typography>
                        <TextAreaDisabledComponent
                          propsData={props}
                          name="lrNote"
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Judul Perjanjian / <i>Title of Agreement</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldMultiDisabledComponent
                    propsData={props}
                    name="titleAgreement"
                  />
                  {props.errors.titleAgreement && (
                    <div className="error-message">
                      {props.errors.titleAgreement}
                    </div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Partner / <i>Counterpart</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="counterPart"
                  />
                  {props.errors.counterPart && (
                    <div className="error-message">
                      {props.errors.counterPart}
                    </div>
                  )}
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "20px" }}
                    gutterBottom
                  >
                    <u>
                      Jenis Dokumen / <i>Document Type</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistDisabledValidationComponent
                    propsData={props}
                    onChildDataChange={(dataChild) =>
                      setValidationDocumentType(dataChild)
                    }
                    name="documentType"
                    ddlData={listDocumentType}
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {dataUpload.map((obj, i) => (
                    <div>
                      <UploadMultipleFileComponent
                        disabled
                        file={obj}
                        fileIndex={i}
                        onUploadFile={() => {}}
                        onDeleteFile={() => {}}
                        onAddMoreData={() => {}}
                        onDeleteData={() => {}}
                        onDownloadFile={(fileIndex) => {
                          handleChangeDownload("multi", i, fileIndex, null);
                        }}
                        requiredValidationMessage={errorUpload}
                      />
                    </div>
                  ))}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {validationDocumentType ==
                    DocumentType.toId(DocumentType.Hardcopy) && (
                    <div style={{ paddingBottom: "20px" }}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Lokasi / <i>Area</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <DropdownlistDisabledComponent
                        propsData={props}
                        name="area"
                        ddlData={listAreaLocation}
                      />
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingTop: "20px" }}
                      >
                        <u>
                          Ruang / <i>Room</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <TextFieldMultiDisabledComponent
                        propsData={props}
                        name="address"
                      />
                      {props.errors.address && (
                        <div className="error-message">
                          {props.errors.address}
                        </div>
                      )}
                    </div>
                  )}
                  {(getRole.roleId == "RL230000002" ||
                    (getRole.roleId != "RL230000002" &&
                      validationRequestType ==
                        RequestType.toId(RequestType.DokumenMaster))) && (
                    <>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Periode Penggunaan (Khusus Dokumen Master) /{" "}
                          <i>Period of Use (Master Document only)</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <Grid container spacing={3} item md={12} xs={12}>
                        <Grid item md={6} xs={6}>
                          <TextFieldDateDisabledComponent
                            propsData={props}
                            name="startDatePeriod"
                          />
                          {props.errors.startDatePeriod && (
                            <div className="error-message">
                              {props.errors.startDatePeriod}
                            </div>
                          )}
                        </Grid>
                        <Grid item md={6} xs={6}>
                          <TextFieldDateDisabledComponent
                            propsData={props}
                            name="endDatePeriod"
                          />
                          {props.errors.endDatePeriod && (
                            <div className="error-message">
                              {props.errors.endDatePeriod}
                            </div>
                          )}
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
                {requestStatusID != RequestStatus.toId(RequestStatus.Pending) &&
                  requestStatusID !=
                    RequestStatus.toId(RequestStatus.Canceled) &&
                  requestStatusID !=
                    RequestStatus.toId(RequestStatus.Rejected) &&
                  requestStatusID !=
                    RequestStatus.toId(RequestStatus.Draft) && (
                    <Grid item lg={6} md={12} xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Jenis Permohonan / <i> Request Type</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <DropdownlistDisabledComponent
                        propsData={props}
                        name="requestType"
                        ddlData={listRequestType}
                      />
                    </Grid>
                  )}
                {validationRequestType ==
                RequestType.toId(RequestType.DokumenMaster) ? (
                  <Grid item lg={6} md={12} xs={12}>
                    {/* logic tambahan jika file upload realization kosong gak usah di show */}
                    {uploadRealizationDM[0].files[0].fileName != "" && (
                      <>
                        {uploadRealizationDM.map((obj, i) => (
                          <div>
                            <UploadMultipleFileComponent
                              disabled
                              file={obj}
                              fileIndex={i}
                              onUploadFile={() => {}}
                              onDeleteFile={() => {}}
                              onAddMoreData={() => {}}
                              onDeleteData={() => {}}
                              onDownloadFile={(fileIndex) => {
                                handleChangeDownload(
                                  "single",
                                  i,
                                  fileIndex,
                                  "Master Document Realization"
                                );
                              }}
                              requiredValidationMessage=""
                            />
                          </div>
                        ))}
                      </>
                    )}

                    {/* logic tambahan */}
                    {(requestStatusName == "Finished" ||
                      requestStatusName == "Finished - Revised" ||
                      requestStatusName == "Finished - Canceled" ||
                      requestStatusName == "Request Revise") &&
                      requestTypeId ==
                        RequestType.toId(RequestType.DokumenMaster) && (
                        <>
                          {fileSuratPersetujuanGeneratePdf.map((obj, i) => (
                            <div>
                              <UploadMultipleFileComponent
                                disabled
                                file={obj}
                                fileIndex={i}
                                onUploadFile={() => {}}
                                onDeleteFile={() => {}}
                                onAddMoreData={() => {}}
                                onDeleteData={() => {}}
                                onDownloadFile={(fileIndex) => {
                                  handleDownloadSuratPersetujuanGeneratePdf(
                                    "single",
                                    i,
                                    fileIndex
                                  );
                                }}
                                requiredValidationMessage=""
                              />
                            </div>
                          ))}
                        </>
                      )}
                  </Grid>
                ) : (
                  <Grid item lg={6} md={12} xs={12} />
                )}
                {(validationRequestType ==
                  RequestType.toId(RequestType.SuratKuasa) ||
                  (validationRequestType ==
                    RequestType.toId(RequestType.DokumenMaster) &&
                    validationSignerAndLeader == false)) &&
                  props.initialValues.delegatee != null && (
                    <>
                      <Grid item lg={6} md={12} xs={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          <u>
                            Penerima Kuasa / <i> Delegatee</i>
                          </u>
                        </Typography>
                        <AutocompleteDisabledComponent
                          propsData={props}
                          name="delegatee"
                        />
                        {props.errors.delegatee && (
                          <div className="error-message">
                            {props.errors.delegatee}
                          </div>
                        )}
                      </Grid>
                      <Grid item lg={6} md={12} xs={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          <u>
                            Subtitusi / <i> Substitutor</i>
                          </u>
                        </Typography>
                        <AutocompleteDisabledComponent
                          propsData={props}
                          name="substitutor"
                        />
                        {props.errors.substitutor && (
                          <div className="error-message">
                            {props.errors.substitutor}
                          </div>
                        )}
                      </Grid>
                    </>
                  )}
                {(validationRequestType ==
                  RequestType.toId(RequestType.SuratKuasa) ||
                  (validationRequestType ==
                    RequestType.toId(RequestType.DokumenMaster) &&
                    validationSignerAndLeader == false)) &&
                  props.initialValues.noPowerAttorney != "" &&
                  props.initialValues.noPowerAttorney != null && (
                    <>
                      <Grid item lg={6} md={12} xs={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          <u>
                            No. Surat Kuasa /{" "}
                            <i> Number of Power of Attorney</i>
                          </u>
                          <span style={{ color: "red" }}> *</span>
                        </Typography>
                        <TextFieldDisabledComponent
                          propsData={props}
                          name="noPowerAttorney"
                        />
                        {props.errors.noPowerAttorney && (
                          <div className="error-message">
                            {props.errors.noPowerAttorney}
                          </div>
                        )}
                      </Grid>
                      <Grid item lg={6} md={12} xs={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          <u>
                            No. Surat Substitusi /{" "}
                            <i> Number of Substitution Letter</i>
                          </u>
                        </Typography>
                        <TextFieldDisabledComponent
                          propsData={props}
                          name="noSubstitutor"
                        />
                        {props.errors.noSubstitutor && (
                          <div className="error-message">
                            {props.errors.noSubstitutor}
                          </div>
                        )}
                      </Grid>
                      {uploadSK[0].files[0].fileName != "" && (
                        <Grid item lg={6} md={12} xs={12}>
                          {uploadSK.map((obj, i) => (
                            <div>
                              <UploadMultipleFileComponent
                                disabled
                                file={obj}
                                fileIndex={i}
                                onUploadFile={() => {}}
                                onDeleteFile={() => {}}
                                onAddMoreData={() => {}}
                                onDeleteData={() => {}}
                                onDownloadFile={(fileIndex) => {
                                  handleChangeDownload(
                                    "single",
                                    i,
                                    fileIndex,
                                    "Hardcopy SK"
                                  );
                                }}
                                requiredValidationMessage={errorUploadSK}
                              />
                            </div>
                          ))}
                        </Grid>
                      )}
                    </>
                  )}
              </Grid>

              {listDataRevision.length > 0 && (
                <>
                  <Box sx={{ fontSize: "25px", marginTop: "3%" }}>
                    Permintaan Revisi / <i>Request Revise from Requestor</i>
                    <hr />
                  </Box>
                  {listDataRevision.map((obj, i) => (
                    <RevisionDisabledComponent
                      allObj={{ ...obj, requestNumber }}
                    />
                  ))}
                </>
              )}

              {getRole.roleId == "RL230000002" ? (
                dataCommentEndUser.length > 0 && (
                  <>
                    <Box sx={{ fontSize: "25px", marginTop: "3%" }}>
                      Komentar / <i>Comments for Requestor</i>
                      <hr />
                    </Box>
                    {dataCommentEndUser.map((obj, i) => (
                      <CommentDisabledComponent
                        allObj={obj}
                        key={obj.commentID}
                        onChildDownload={(dataChild) =>
                          handleChangeDownloadCommentEndUser(dataChild, i)
                        }
                      />
                    ))}
                  </>
                )
              ) : (
                <>
                  {dataCommentEndUser.length > 0 && (
                    <>
                      <Box sx={{ fontSize: "25px", marginTop: "3%" }}>
                        Komentar / <i>Comments for Requestor</i>
                        <hr />
                      </Box>
                      {dataCommentEndUser.map((obj, i) => (
                        <CommentDisabledComponent
                          allObj={obj}
                          key={obj.commentID}
                          onChildDownload={(dataChild) =>
                            handleChangeDownloadCommentEndUserAndCL(
                              dataChild,
                              i,
                              "End User"
                            )
                          }
                        />
                      ))}
                    </>
                  )}

                  {dataCommentCL.length > 0 && (
                    <>
                      <Box sx={{ fontSize: "25px", marginTop: "3%" }}>
                        Komentar / <i>Comments for Corporate Legal</i>
                        <hr />
                      </Box>
                      {dataCommentCL.map((obj, i) => (
                        <CommentDisabledComponent
                          allObj={obj}
                          key={obj.commentID}
                          onChildDownload={(dataChild) =>
                            handleChangeDownloadCommentEndUserAndCL(
                              dataChild,
                              i,
                              "CL"
                            )
                          }
                        />
                      ))}
                    </>
                  )}
                </>
              )}

              {getRole.roleId == "RL230000002" &&
                (requestStatusName == "Finished" ||
                  requestStatusName == "Finished - Revised" ||
                  (requestStatusName == "Pending" && userRevision > 0)) && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      paddingTop: "20px",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        m: 1,
                        width: "150px",
                        textTransform: "none",
                        fontWeight: "bold",
                        margin: 0,
                      }}
                      onClick={() => handleRequestRevision("Request Revise")}
                    >
                      Request Revise
                    </Button>
                  </Box>
                )}

              <Box
                sx={{
                  display: "flex",
                  paddingTop: "20px",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(0)}
                >
                  {"<<"} Previous Page
                </Button>
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(2)}
                >
                  {">>"} Next Page
                </Button>
              </Box>
            </TabPanel>
            <TabPanel value={valueTab} index={2}>
              <TransactionHistoryModal />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  paddingTop: "20px",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(1)}
                >
                  {"<<"} Previous Page
                </Button>
              </Box>
            </TabPanel>

            <ConfirmationDialogRevisionUser
              open={openConfirmation}
              onConfirm={(e) => {
                handleClickRevision(e);
              }}
              onCancel={() => {
                setOpenConfirmation(false);
              }}
              isMandatory
              action={actionButtonClick}
            />

            <ConfirmationDialog
              open={openConfirmationSubmit}
              title="Confirmation"
              message="Are you sure you want to proceed ?"
              onConfirm={() => {
                handleSubmitRequestRevision(tempRevisionData);
              }}
              onCancel={() => {
                setOpenConfirmationSubmit(false);
              }}
            />
            <Loading open={loadingActive} />
            <Feedback
              open={openFeedback}
              message={feedbackText}
              feedbackType={feedbackType}
            />
          </form>
        )}
      </Formik>
    </Container>

    // <Grid item lg={6} md={12} xs={12}>
    //                 <Typography variant="subtitle1" gutterBottom>
    //                   Komentar Legal / Comment from Legal
    //                 </Typography>
    //                 <TextFieldMultiDisabledComponent parentToChild="Komentarnya" />
    //                 <Typography variant="subtitle1" gutterBottom>
    //                   Bukti / Evidence
    //                 </Typography>
    //                 <DownloadFileComponent fileName="bukti.jpg" />
    //               </Grid>
    // <div>
    //   <h1>My Form</h1>
    //   <Formik
    //     initialValues={initialValues}
    //     onSubmit={onSubmitForm}
    //     validate={validation}
    //   >
    //     {(props) => (
    //       <form onSubmit={props.handleSubmit}>
    //         <TextFieldComponent propsData={props} name="name" />

    //         {/* <TextFieldComponent onChildDataChange={handleDataTextArea}/> */}
    //         {props.errors.name && (
    //           <div id="feedback">{props.errors.name}</div>
    //         )}

    //         <TextFieldComponent propsData={props} name="email" />
    //         {props.errors.email && (
    //           <div id="feedback">{props.errors.email}</div>
    //         )}

    //         <TextFieldDateComponent propsData={props} name="startDate" />
    //         {props.errors.startDate && (
    //           <div id="feedback">{props.errors.startDate}</div>
    //         )}

    //         <TextFieldDateComponent propsData={props} name="endDate" />
    //         {props.errors.endDate && (
    //           <div id="feedback">{props.errors.endDate}</div>
    //         )}

    //         <TextFieldComponent propsData={props} name="binusianName" />
    //         {props.errors.binusianName && (
    //           <div id="feedback">{props.errors.binusianName}</div>
    //         )}

    //         <button type="submit">Submit</button>
    //       </form>
    //     )}
    //   </Formik>
    // </div>

    // <Container>
    //   <DatePickerComponent onChildDataChange={handleDataFromChild}/>
    //   <TextFieldMultiComponent onChildDataChange={handleDataTextArea}/>
    //   <TextFieldMultiComponent onChildDataChange={handleDataTextArea2}/>
    //   <DropdownlistComponent/>
    //   {/* <TextAreaComponent onChildDataChange={handleDataTextArea}/> */}
    //   {/* <TextAreaComponent onChildDataChange={handleDataTextArea2}/> */}
    // </Container>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export default ViewForm;
